import { render, staticRenderFns } from "./update_jifen.vue?vue&type=template&id=4687c27b&scoped=true&"
import script from "./update_jifen.vue?vue&type=script&lang=js&"
export * from "./update_jifen.vue?vue&type=script&lang=js&"
import style0 from "./update_jifen.vue?vue&type=style&index=0&id=4687c27b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4687c27b",
  null
  
)

export default component.exports